var map = {
	"./bilibili.png": "b6a5",
	"./douyin.png": "1091",
	"./facebook.png": "5846",
	"./instagram.png": "c350",
	"./tiktok.png": "7e4d",
	"./weibo.png": "eaf4",
	"./weixin.png": "28c3",
	"./xiaohongshu.png": "ad47",
	"./youtube.png": "5418",
	"./zhihu.png": "17f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ab9";